export const FINGERPRINT_KEY = 'fingerprintId';
